import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet'
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { Link, Route,  useNavigate,  useParams } from 'react-router-dom';
import { Button, Input, Main, PageHeader, Skeleton } from '../../Components'
import { updateUserOrganizationByID, updateOrganizationByID, updateOrganization } from '../../Redux/features/authSlice';


import './settings.css'

export function Settings() {

	 
	const effectCalled = useRef(false)
	const navigate = useNavigate()
	const { user , org } = useSelector((state) => state.auth)
	const dispatch = useDispatch();

	const [isLoading, setIsLoading] = useState(false)
	const [isLoadingOrganizationData, setIsLoadingOrganizationData] = useState(false)

	const [formData, setFormData] = useState({
		name: "",
	});
	const [formValidation, setFormValidation] = useState({
		name : "",
		 
	})


	useEffect(() => {

		if(effectCalled.current){ return ;}
		 
		async function fetchData() {
			
			await getOrganizationData();
		}
		fetchData();

		effectCalled.current = true ;
	  
	}, [])



	/**
	 * 
	 * @returns 
	 */
	const getOrganizationData = () => {

		return new Promise(async(resolve, reject) => { 

			setIsLoadingOrganizationData(true)
			
			
			
			
			if (user && user.token && org && org?.id ) {
				
				let params = { }

				const token = user?.token;


				await axios.get(`${process.env.REACT_APP_API_URL}/organizations/${org?.id}` , {
					params :params,
					headers: {
						'Authorization': `Bearer ${token}`
					},
				})
				.then( res => res.data )
				.then( data => {

					setFormData( (prevState) => ({ 
						...prevState,
						name: data?.name,
						 
					}))

					 
					 

					setIsLoadingOrganizationData(false)
		
					resolve(data) 
		
				})
				.catch(error => {
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					setIsLoadingOrganizationData(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
							reject(`Something went wrong. thank you try later.`)
						}
					}
				})
			}else{
				setIsLoadingOrganizationData(false)
			}

		})
	} 


	/**
	 * 
	 * @param {*} e 
	 * @returns 
	 */
	const onSubmit = async (e) => {
		e.preventDefault();

		return new Promise( async (resolve, reject) => { 
			
			setIsLoading(true)
			let validationName = '';
			validationName = (formData?.name === '') ? "Name can't be blank." : (formData?.name?.length < 5 ? 'Name must be a valid format ( at least 5 characters )' : '')
			setFormValidation((prevState) => ({
				...prevState,
				// name: (formData.name === '') ? "Name can't be blank." : '',
				name : validationName
			}))

			if( validationName !=='' ){
				toast.error("Please complete all required fields") 

				 
				setIsLoading(false)

				return 
			}

			
			
			
			
			
			if (user && user.token && org && org?.id && formData?.id !==null ) {

				
				let params = { 
					name : formData?.name,
					 
				}
			 

				const token = user?.token;


				await axios.put(`${process.env.REACT_APP_API_URL}/organizations/${org?.id}`, params , {
					headers : {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${token}`,//'JWT token...'
					}
				} )
				.then( res => res.data )
				.then( data => {

					setIsLoading(false)

					
					toast.success('Your account has been successfully updated') 

					// ! Update REDUX > ORGANIZATIONS [ INDEX ] 
					dispatch(updateUserOrganizationByID({
						organization_id : org?.id ,
						data : {
							name : data?.name
						} 
					}))
					dispatch(updateOrganization({
						name : data?.name
					}))
					 

					 
		
					resolve(data.data) 
		
				})
				.catch(error => {
					//console.log(error)
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					setIsLoading(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							 
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
							reject(`Something went wrong. thank you try later.`)
						}
					}

					toast.error('Something went wrong, please try again later.') 
				})
			}else{
				setIsLoading(false)
				toast.error('Something went wrong, please try again later.') 
			}


		})

	}

	/**
	 * 
	 * @param {*} e 
	 */
	const onChange = (e) => {

		switch(e.target.name){
			case "name" : 
				setFormValidation((prevState) => ({
					...prevState,
					name : (e.target.value === '') ? "Name can't be blank." : (e.target.value.length < 5 ? 'Name must be a valid format ( at least 5 characters )' : '')
				}))
				
				break;
			 
			
		}

		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: (e.target.type ==='checkbox') ? e.target.checked :  e.target.value,
		}));
	};
	 

	return (
		<>
		<Helmet>
			<title>{`Organization settings - ${process.env.REACT_APP_APP_NAME}`}</title>
		</Helmet>
		<Main 
			breadcrumbsItems={[
				{ name: 'Home', link: '/' },
				{ name: 'Settings', link: ``},
			]}
			 >
				<PageHeader
					title="Settings"
					// description="Give your account a recognisable name, so your team mates can easily switch between accounts."
					/>
				 <form>
					{
						isLoadingOrganizationData === true 
						? <>
							
							<Skeleton className="mb-10" width={40} height={16} radius="sm" />
							<Skeleton className="mb-10" width="60%" height={36} radius="sm" />
							<Skeleton width={100} height={36} radius="sm" />
						</>
						: (
							<>
					
						<Input
							label="Organization Name"
							placeholder=""
							name="name"
							onChange={onChange}
							value={formData?.name}
							required
							// note={organization_id}
							error={formValidation?.name}
							
							/>
						<div className="field-group submit-fields-group fluid form_fixed_footer">
							<div className="container flex-start">
								<Button  onClick={onSubmit}  loading={isLoading} >{'Save'}</Button>
							</div>
						</div>
						 

							</>
						)
					}
				</form>	
		 </Main>
		</>
	)
}
